import { createAction } from "~/utils/actions";

export default {
	...createAction("ERROR"),
	...createAction("CLEAR_ERROR"),
	...createAction("SERVER_VALIDATION_ERROR"),
	...createAction("CLEAR_VALIDATION_ERROR"),
	...createAction("VALIDATE_EMAIL"),
	...createAction("READING_MODE_ERROR"),
	...createAction("RPM_ACCESS_ERROR"),
};
